import { PendingZoneGroup } from 'features/evacZones/types';
import { TFunction } from 'i18next';
import { formatNameList } from 'shared/utils';

// A rename hold keeps the zone live under its old name with the new name pending.
export const isRenameHoldGroup = (zoneGroup: PendingZoneGroup): boolean => {
  return (
    zoneGroup.zones.length > 0 &&
    zoneGroup.zones.every((zone) => Boolean(zone.pendingDisplayName))
  );
};

export const generatePendingZoneNames = (
  t: TFunction,
  zoneGroup: PendingZoneGroup,
): { activeNames: string; resultingNames: string } => {
  const activeZoneNames = zoneGroup.zones
    .filter((zone) => zone.isActive)
    .map((z) => z.displayName)
    .sort();

  // Get names of zones that will exist after the operation completes.
  // A held rename keeps the old displayName live, the new name is pendingDisplayName.
  const resultingZoneNames = zoneGroup.zones
    .filter(
      (zone) =>
        zone.childUids?.includes(zone.uidV2) ||
        !zone.isActive ||
        zone.pendingDisplayName,
    )
    .map((zone) => zone.pendingDisplayName ?? zone.displayName)
    .sort();

  const formattedActiveNames = formatNameList(t, activeZoneNames);
  const formattedResultingNames = formatNameList(t, resultingZoneNames);

  return {
    activeNames: formattedActiveNames,
    resultingNames: formattedResultingNames,
  };
};
